// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-colorattributeradio_default__2g7fd","active":"idt-colorattributeradio_active__371du","preview":"idt-colorattributeradio_preview__u9zii"};